import { push } from '../../common/utils'

import {
  getBrandDefinitionBreadcrumbItemByTaskId,
  getBrandGatewayBreadcrumbItemByTaskId,
  getDishReviewBreadcrumbItemByTaskId,
  getMenuDefinitionBreadcrumbItemByTaskId,
  getMenuScrapingBreadcrumbItemByTaskId,
} from './get-breadcrumb-item-paths'

const getBreadcrumbItemsForDishReviewTaskPage = ({ relatedTasks }) => {
  const {
    brandGatewayTask,
    brandDefinitionTask,
    menuDefinitionTask,
    menuScrapingTask,
    dishReviewTask,
  } = relatedTasks

  const items = []

  push(items, getBrandGatewayBreadcrumbItemByTaskId(brandGatewayTask))
  push(items, getBrandDefinitionBreadcrumbItemByTaskId(brandDefinitionTask))
  push(items, getMenuDefinitionBreadcrumbItemByTaskId(menuDefinitionTask))
  push(items, getMenuScrapingBreadcrumbItemByTaskId(menuScrapingTask.id))
  push(items, getDishReviewBreadcrumbItemByTaskId(dishReviewTask.id))

  return items
}

export default getBreadcrumbItemsForDishReviewTaskPage
